import React, { Component } from 'react';

class FilterSet extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      openFilter: undefined
    }
  }

  componentWillReceiveProps(newProps) {
    this.setState({openFilter: undefined});
  }

  render() {

    let toggle = (filterTitle) => {
      if (filterTitle === this.state.openFilter)
        this.setState({openFilter: undefined});
      else
        this.setState({openFilter: filterTitle});
    };

    let filters = this.props.children;

    const filterWithProps = React.Children.map(filters,
     
     (filter) => {
      let title = filter.props.title;
      let open = this.state.openFilter === filter.props.title;
      return React.cloneElement(filter, {
         toggle: toggle.bind(this, title), open: open
       })
      }

    );

    return (

      <span>
        {filterWithProps}
      </span>

    );
  }

}

export default FilterSet;



// WEBPACK FOOTER //
// ./src/js/components/filter/FilterSet.jsx